import script from "./CardsChatProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsChatProduct.vue?vue&type=script&setup=true&lang=js"

import "./CardsChatProduct.vue?vue&type=style&index=0&id=2bcaedc3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bcaedc3"]])

export default __exports__